import React, { useEffect, useState } from "react";
import { AsyncSelect } from "@caelor/ui";
import { searchForPages } from "../../../api/confluence-api";
import { getPageById, getPagesById } from "../../../api/page-api";
import { useTranslation } from "react-i18next";

export function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

export const createProfileLink = (accountId) =>
  `${window.AP._hostOrigin}/wiki/plugins/servlet/ac/com.caelor.confluence.cloud.cosmos/caelor-cosmos-portal?ac.cosmosPage=profile&ac.accountId=${accountId}`;

export const localizeDate = (date, locale) => {
  return new Date(date).toLocaleDateString(locale, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const mapPage = (page) => ({
  contentId: page.content.id,
  type: page.content.type,
  name: page.content.title,
  space: { name: page.content.space.name },
  excerpt: htmlDecode(page.excerpt),
  url: `${window.AP._hostOrigin}/wiki${page.url}`,
  createdBy: page.content.history.createdBy.displayName,
  lastModified: page.friendlyLastModified,
  label: page.content.title,
  value: page.content.id,
});

const mapPageV2 = (page) => ({
  contentId: page.id,
  type: "page",
  name: page.title,
  space: "-",
  excerpt: "-",
  url: `${window.AP._hostOrigin}/wiki${page._links.tinyui}`,
  createdBy: "-",
  lastModified: page.version.createdAt,
  label: page.title,
  value: page.id,
});

const PagePicker = ({
  placeholder,
  selectedPages = [],
  onSelect = () => {},
  isSubPages = false,
  loadInitialOptions = false,
}) => {
  const { t } = useTranslation();
  const [subPage, setSubPage] = useState([]);

  useEffect(() => {
    if (!loadInitialOptions) return;

    if ((selectedPages ?? []).filter((v) => v).length > 0) {
      getPagesById(selectedPages)
        .then((res) => {
          const results = JSON.parse(res.body)?.results || [];
          const mapped = results.map((r) => mapPageV2(r));
          setSubPage(mapped[0]);
        })
        .catch((e) => {});
    }
  }, [loadInitialOptions]);

  const loadOptions = async (query) => {
    return (await searchForPages(query)).results
      .map((page) => mapPage(page))
      .filter((page) => {
        if (!selectedPages?.length) return true;
        return !selectedPages?.find((pageId) => pageId === page.contentId);
      });
  };

  return (
    <AsyncSelect
      isSearchable
      value={isSubPages ? subPage : []}
      placeholder={placeholder || t("select-page")}
      isClearable
      onChange={(option) => {
        onSelect(option);
        setSubPage(option);
      }}
      loadOptions={loadOptions}
    />
  );
};

export default PagePicker;
